import { http } from './http';

/**
 * Web Push subscription (in-app OTP rail B). Mirrors backend ShowcasePushController
 * (/api/v1/showcase/push/*).
 */

export interface PushSubscribePayload {
  endpoint: string;
  keys: { p256dh: string; auth: string };
  deviceId?: string | null;
}

export const vitrinePushApi = {
  /** VAPID public key to subscribe with; null when the backend has Web Push disabled (204). */
  async vapidPublicKey(): Promise<string | null> {
    try {
      const r = await http.get<{ publicKey?: string }>('/v1/showcase/push/vapid-public-key');
      return r.data?.publicKey ?? null;
    } catch {
      return null;
    }
  },
  subscribe(payload: PushSubscribePayload) {
    return http.post<void>('/v1/showcase/push/subscribe', payload).then(() => undefined);
  },
  unsubscribe(endpoint: string) {
    return http.delete<void>('/v1/showcase/push/unsubscribe', { data: { endpoint } }).then(() => undefined);
  },
};
